
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPo06DtPendingCNforCnrtvDialog extends Serenity.EntityDialog<PoPo06DtPendingCNforCnrtvRow, any> {
        protected getFormKey() { return PoPo06DtPendingCNforCnrtvForm.formKey; }
        protected getIdProperty() { return PoPo06DtPendingCNforCnrtvRow.idProperty; }
        protected getLocalTextPrefix() { return PoPo06DtPendingCNforCnrtvRow.localTextPrefix; }
        protected getNameProperty() { return PoPo06DtPendingCNforCnrtvRow.nameProperty; }
        protected getService() { return PoPo06DtPendingCNforCnrtvService.baseUrl; }
        protected getDeletePermission() { return PoPo06DtPendingCNforCnrtvRow.deletePermission; }
        protected getInsertPermission() { return PoPo06DtPendingCNforCnrtvRow.insertPermission; }
        protected getUpdatePermission() { return PoPo06DtPendingCNforCnrtvRow.updatePermission; }

        protected form = new PoPo06DtPendingCNforCnrtvForm(this.idPrefix);

    }
}